import _ from "lodash";
import React from "react";

import MemberImage from "../widgets/MemberImage";
import * as followUpActions from "../../actions/followUpActions";
import { withRouter } from "react-router";
import { createUrl } from "../../utils/UrlUtils";
import { Routes } from "../../constants/Routes";
import { IconButton } from "@mui/material";
import ClinicNoteImage from "../../assets/images/chart/ClinicalNotesWhite@2x.png";
import { showSideBar as showClinical } from "../../actions/chartActions";
import viewTypes from "../../constants/chart-sidebar/viewTypes";
import {
  getCompanyFormatDate,
  getCompanyFormatFullDate,
  getCompanyFormatTime,
} from "../../helpers/DateUtils";

class FollowUpCell extends React.Component {
  render() {
    const {
      item,
      history: { push },
    } = this.props;

    const photo = item?.patient?.photo?.url;
    const chartNumber = item?.patient?.chartNumber;

    const editFormHandler = (item) => {
      this.props.dispatch(followUpActions.toggleEditForm(item));
      this.props.dispatch(followUpActions.getConsultationsList(item));
    };

    return (
      <div
        style={item.responded === false ? { background: "#eeb06b" } : {}}
        className={`waiting-list-row follow-up-row${item.done ? " follow-up-row-done" : ""}`}
      >
        <div className="waiting-list-cell follow-up-cell">
          <div className="waiting-list-cell-body follow-up-cell-body">
            <div
              onClick={() => editFormHandler(item)}
              className="member-container follow-up-cell follow-up-cell-1"
              style={{ cursor: "pointer" }}
            >
              <MemberImage size={70} photoUrl={photo} />
            </div>
            <div
              onClick={() => editFormHandler(item)}
              className="info-container follow-up-cell follow-up-cell-5"
              style={{ cursor: "pointer" }}
            >
              {item.doctor.name}
            </div>
            <div
              onClick={() => editFormHandler(item)}
              className="info-container follow-up-cell follow-up-cell-5"
              style={{ cursor: "pointer" }}
            >
              {_.get(item, "creator.name", "N/A")}
            </div>
            <div
              onClick={() => editFormHandler(item)}
              className="info-container follow-up-cell follow-up-cell-5"
              style={{ cursor: "pointer" }}
            >
              <div>
                <div className="patient-name">{_.get(item, "patient.fullName")}</div>
              </div>
            </div>
            <div
              onClick={() => editFormHandler(item)}
              className="info-container follow-up-cell follow-up-cell-5"
              style={{ cursor: "pointer" }}
            >
              <div>
                <div className="patient-name">#{chartNumber}</div>
              </div>
            </div>
            <div className="follow-up-cell follow-up-cell-6 flex-grow-1">
              <div>{_.get(item, "type.name")}</div>
            </div>
            <div className="follow-up-cell follow-up-cell-6">
              <div>
                {_.get(item, "appointmentDate")
                  ? [
                      getCompanyFormatDate(_.get(item, "appointmentDate")),
                      getCompanyFormatTime(_.get(item, "appointmentDate")),
                    ]
                      .filter(Boolean)
                      .join(" ")
                  : "-"}
              </div>
            </div>
            <div className="follow-up-cell follow-up-cell-5">
              <div>{getCompanyFormatDate(_.get(item, "date"))}</div>
            </div>
            <div className="follow-up-cell follow-up-cell-6">
              <div>
                {_.get(item, "lastReplayDate")
                  ? getCompanyFormatFullDate(_.get(item, "lastReplayDate"))
                  : "-"}
              </div>
            </div>
            <div className="follow-up-cell follow-up-cell-5">
              <div>{_.get(item, "lastReplayMember.name") || "-"}</div>
            </div>
            <div className="follow-up-cell follow-up-cell-4">
              {!_.isEmpty(item.patient) && (
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    push(
                      createUrl(Routes.PatientProfile, {
                        query: {
                          patientKey: item.patient.patientKey,
                        },
                      }),
                    )
                  }
                >
                  Patient Profile
                </button>
              )}

              {!_.isEmpty(item.patient) && (
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    this.props.dispatch(
                      followUpActions.setData({
                        patientKey: item.patient.patientKey,
                        doctorId: item.doctor.id,
                      }),
                    );
                    push(
                      createUrl(Routes.DashboardChart, {
                        params: { type: item.appointmentId ? "Visit" : "Planning" },
                        query: {
                          patientKey: item.patient.patientKey,
                          doctorId: item.doctor.id,
                          appointmentId: item.appointmentId,
                        },
                      }),
                    );
                  }}
                >
                  Patient Chart
                </button>
              )}

              {!_.isEmpty(item.patient) && (
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    const query = this.props.dispatch(
                      followUpActions.openAppointment({
                        doctor: item.doctor.id,
                        patientKey: item.patient.patientKey,
                      }),
                    );
                    this.props.history.push(
                      createUrl(Routes.DashboardAppointment, {
                        query,
                        params: { id: 0 },
                      }),
                    );
                  }}
                >
                  Schedule
                </button>
              )}

              {!item.done && (
                <button
                  className="btn btn-primary"
                  onClick={() => this.props.dispatch(followUpActions.complete(item))}
                >
                  Complete
                </button>
              )}
              <IconButton
                title="Clinical Notes"
                onClick={() =>
                  this.props.dispatch(
                    showClinical(viewTypes.clinicalNote, {
                      patientKey: _.get(item, "patient.patientKey"),
                    }),
                  )
                }
              >
                <img alt={""} src={ClinicNoteImage} className="zoom-2x" />
              </IconButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(FollowUpCell);
